import { z } from 'zod';

export const ScheduledDowngradeDataSchema = z.object({
  subscriptionId: z.string(),
  subscriptionScheduleId: z.string(),
  planName: z.string(),
  scheduledDate: z.number(),
});

export type ScheduledDowngradeData = z.infer<typeof ScheduledDowngradeDataSchema>;
